import { Errors, ValidationTypes } from "./Constant";

const Validation = (validationItem, type, regex = null) => {
  let ErrorMessage = "";

  switch (type) {
    case ValidationTypes.USERNAME_TYPE:
      if(validationItem.length === 0){
        ErrorMessage = Errors.IS_REQUIRED;
        break;
      }
      if(validationItem.length < 3){
        ErrorMessage = Errors.AT_LEAST_THREE;
        break;
      }
      break;

    case ValidationTypes.SELECT_TYPE:
      if(validationItem.length === 0){
        ErrorMessage = Errors.IS_REQUIRED;
        break;
      }
      break;

    case ValidationTypes.PASSWORD_TYPE:
      if(validationItem.length === 0){
        ErrorMessage = Errors.IS_REQUIRED;
        break;
      }
      if(validationItem.length < 6){
        ErrorMessage = Errors.AT_LEAST_PASSWORD;
        break;
      }
      break;

    case ValidationTypes.IS_REQUIRED:
      if(validationItem.length === 0){
        ErrorMessage = Errors.IS_REQUIRED;
        break;
      }
      break;
  
    default:
      throw new Error();
  }

  return ErrorMessage;
};

export default Validation;